import { useState } from "react";
import { Power } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function RetirementToggle() {
  const { user, refresh } = useAuth();
  const rc = user?.retirement_contribution;
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  if (!rc?.applicable) return null;
  const on = rc.enabled !== false;
  const toggle = async () => {
    setBusy(true); setErr("");
    try { await api.patch("/commitments/retirement", { enabled: !on }); await refresh(); }
    catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-3" data-testid="retirement-toggle-wrap">
      <button onClick={toggle} disabled={busy} aria-pressed={on}
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors ${on ? "border-forest/40 bg-mint text-forest" : "border-sand text-moss hover:text-ink"}`}
        data-testid="retirement-toggle">
        <Power className="w-3 h-3" /> Automatic ${Number(rc.contribution_amount || 100).toFixed(0)} deposits: {on ? "On" : "Off"}
      </button>
      <div className="text-[11px] text-sage mt-1" data-testid="retirement-toggle-hint">{on ? "Optional — turn off to start later; your balance stays locked." : "Paused until you turn it back on. Nothing leaves Spending for retirement."}</div>
      {err && <div className="text-xs text-clay mt-1">{err}</div>}
    </div>
  );
}
